var _rect, _rect2, _rect3, _rect4, _rect5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcByApp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 5,
    fill: "#D2464F"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4.69751,
    y: 4.69751,
    width: 6.32028,
    height: 6.32028,
    rx: 0.683274,
    stroke: "white",
    strokeWidth: 1.02491
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 4.69751,
    y: 12.9822,
    width: 6.32028,
    height: 6.32028,
    rx: 0.683274,
    stroke: "white",
    strokeWidth: 1.02491
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 12.9827,
    y: 4.69751,
    width: 6.32028,
    height: 6.32028,
    rx: 0.683274,
    stroke: "white",
    strokeWidth: 1.02491
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 12.9827,
    y: 12.9822,
    width: 6.32028,
    height: 6.32028,
    rx: 0.683274,
    stroke: "white",
    strokeWidth: 1.02491
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcByApp);
export default __webpack_public_path__ + "static/media/ic_by-app.91a1b5aecb07bc8b126be7ff13a53b64.svg";
export { ForwardRef as ReactComponent };